import $ from 'jquery';
(function(){
    'use strict';

    // add video controls

    const $video = $('.banner__video');
    const videoElement = $video.get(0);

    $('.banner__video-button-icon').click(function() {
        const $videoButtonControl = $(this);
        const $videoButtonWrapper = $videoButtonControl.closest('.banner__video-button-wrapper');
        const $videoButton = $videoButtonWrapper.closest('.banner__video-button');

        if (videoElement.paused) {
            $video.trigger('play');
        } else {
            $video.trigger('pause');
        }
        $videoButton.find('.hidden').removeClass('hidden');
        $videoButtonWrapper.addClass('hidden');

    	return false;
 	});

     // add banner above footer on small screens
     const $body = $('body');
     const $main = $body.find('main');
     const $banner = $body.find('.banner--bottom');
     const $footer = $body.find('footer');
     let bannerLayoutDesktop = false;

     const changeBannerPosition = function () {
        var screenWidth = $(window).width();
        const desktopWidth = 1180;
        if (screenWidth >= desktopWidth) {
            if (!bannerLayoutDesktop) {
                bannerLayoutDesktop = true;
                $main.prepend($banner);
                $video.prop("autoplay", true);
                if (videoElement && videoElement.paused) {
                    $('.banner__video-button-icon.play').click();
                }
            }
        } else {
            if (bannerLayoutDesktop) {
                bannerLayoutDesktop = false;
                $video.removeAttr("autoplay");
                $banner.insertBefore($footer);
            }
        }
     }

     const bannerPosition = function () {
        var screenWidth = $(window).width();
        const desktopWidth = 1180;
        if (screenWidth >= desktopWidth) {
            $video.prop("autoplay", true);
            if (videoElement && videoElement.paused) {
                $('.banner__video-button-icon.play').click();
            }
        } else {
            $video.removeAttr("autoplay");
            $banner.insertBefore($footer);
        }
     }

    $(window).resize(function() {
        changeBannerPosition();
    });

    bannerPosition();

}());
